const clearObject = (data: any) => {
  return Object.entries(data).reduce((a, [k, v]) => (v && v !== '' ? (a[k] = v, a) : a), {});
};

export default clearObject;
